import { Modal, ModalProps } from 'antd'
import React from 'react'
import { useIntl } from 'react-intl'

import { PaywallResult } from '@/components/common/modals/PaywallModal/PaywallResult'
import { PaywallState } from '@/hooks/usePaywallModal'
import { buildI18nFunction } from '@/utils/messages'

import styles from './Paywall.module.css'

export type PaywallModalComponentId =
  | 'analytics'
  | 'custom_skill'
  | 'issue_details'
  | 'issue_dismiss'
  | 'issue_export'
  | 'MorePolicies'
  | 'MoreProtectionModes'
  | 'NoAvailableSeats'
  | 'people_insights'
  | 'rule_builder'
  | 'security_insights'
  | `environment`
  | `FixbotEnvironment`

type PaywallModalProps = {
  paywall: PaywallState
} & ModalProps

export function PaywallModal({
  paywall,
  ...props
}: PaywallModalProps): JSX.Element {
  const t = buildI18nFunction(useIntl().formatMessage)

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    props?.onOk && props.onOk(e)
  }

  const closeModal = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    props?.onCancel && props.onCancel(e)
  }

  return (
    <Modal
      {...props}
      centered
      className={styles['paywallModal']}
      data-cy={`PaywallModal.${paywall?.componentId}`}
      footer={false}
      onCancel={closeModal}
      title={t(`PaywallModal.${paywall?.componentId}.title`)}
    >
      <PaywallResult
        feature={paywall?.componentId}
        paywall={paywall}
        onClick={handleClick}
        callbacks={{ closeModal }}
      />
    </Modal>
  )
}
